module.exports = __webpack_public_path__ + "static/img/qrcode.ed5c162.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/qrcode.jpeg
// module id = u66A
// module chunks = 1